import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-title_white_24dp",
  "use": "icon-title_white_24dp-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-title_white_24dp\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\" /><path d=\"M5 4v3h5.5v12h3V7H19V4H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol